import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldInfo } from '../../../../models/forms-response.models';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { EformModalComponent } from '../modals/eform-modal/eform-modal.component';
@Component({
    selector: 'app-component-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolTipComponent implements AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    formFieldConfig:any;
    fieldConfig: any;
    fieldCode: string = ''
    name: string;
    maxlength: string = '';
    hideTitle: boolean;
    isRefresh: boolean = false;
    value: string = '';
    tooltip: any;
    template: '';
    title:string='';
    constructor(private cdref: ChangeDetectorRef,private modal: NzModalService) {
    }

    ngOnInit(): void {
        this.formFieldConfig = JSON.parse(this.formFieldInfo.formFieldConfig);
        this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }
    triggerModal(event:any,data) {
        let title = this.tooltip ? this.tooltip.header : event.displayText
        const modal: NzModalRef = this.modal.create({
        nzTitle: '<h5 class="text-white">' + title + '</h5>',
            nzContent: EformModalComponent,
            nzComponentParams: {
                template: title,
                data: event ? event : null
            },
            nzWidth: 896,
            nzMaskClosable: false,
            nzAutofocus:null
        })
    }
}